export default {"src":"/_next/static/media/logo-xs-colored.31f087c3.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};